import { Avatar } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
// import Grade from "./Grade";
import LongPage from "./LongPage";
import { LtnDTO } from "./LtnTable";
import { useMediaQuery } from '@mui/material';
import AnswerModal from "./AnswerModal";
import RedoCountdown from "./RedoCountdown";
interface LtnListProps {
    list: LtnDTO[],
    boxId?: number,
    fresh?: () => void,
    lastStatus?: boolean,
    returnModal?: 'redoNextDay' | 'minDateFilter'
}

export default function LtnList({ list, boxId, lastStatus, fresh, returnModal }: LtnListProps) {
    const isMobile = useMediaQuery('(max-width: 767px)');
    const [now, setNow] = useState(() => dayjs());
    useEffect(() => {
        if (!lastStatus) return;
        const timer = window.setInterval(() => setNow(dayjs()), 30_000);
        return () => window.clearInterval(timer);
    }, [lastStatus]);
    const getNextTime = (solveTime: string, customDuration: number) => {
        const date = dayjs(solveTime || '2025-01-20').add(customDuration, 'day').format('YYYY-MM-DD');
        return isMobile ? date.slice(5) : date;
    }
    const sortList = [...list].sort((a, b) => {
        if (lastStatus) {
            const aTime = dayjs(a.recordUpdatedAt || a.updatedAt || a.submitTime).valueOf();
            const bTime = dayjs(b.recordUpdatedAt || b.updatedAt || b.submitTime).valueOf();
            return aTime - bTime;
        }
        return dayjs(a.solveTime).isBefore(dayjs(b.solveTime)) ? -1 : 1;
    })
    return <div className="ltn-list">
        {sortList.map((it, index) => <div key={it.id} className={lastStatus ? "ltn-item ltn-item--redo" : "ltn-item"}>
            {/* 序号 */}
            <Avatar className="ltn-avatar" size='small'>{index + 1}</Avatar>
            {/* 默认单行展示 - 过长通过悬浮展示 */}
            <LongPage title={it.title} />
            {lastStatus && <RedoCountdown submitTime={it.submitTime} now={now} />}
            {/* 做题弹窗 */}
            <AnswerModal title={!lastStatus ? `【BOX${boxId}】${it.title}` : it.title} type="answer" topicId={it.id} lastStatus={lastStatus} fresh={fresh} returnModal={returnModal} />
            {/* 升降 */}
            {/* <Grade boxId={boxId} fresh={fresh} ltnId={it.id} /> */}
            {/* 下次做题时间 */}
            {it.solveTime && !lastStatus &&
                <span className="ltn-time">{getNextTime(it.solveTime, it.customDuration)}</span>}
            {/* 修改弹窗答案 - 隔天重做时，没有 boxId */}
            {!lastStatus && <AnswerModal title={it.title} type="rightAnswer" topicId={+it.id} />}
        </div>)}
    </div>
}